import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { response } from "express";
import * as moment from "moment";
import { GlobalService } from "src/app/app-core/lib/global.service";
import { UserService } from "src/app/app-core/services/user.service";
import Swal from "sweetalert2";

@Component({
	selector: 'app-update-registration',
	templateUrl: './update-registration-request.component.html',
	providers: [UserService]
})
export class UpdateRegistrationComponent implements OnInit {
	@Input() subject;

	public form: FormGroup;
	public user;
	public isDisabled = true;

	constructor(
		public global: GlobalService,
		public userService: UserService,
		public router: Router,
		private _fb: FormBuilder,
	) {
		this.initForm();
	}
	
	ngOnInit() {
		this.updateForm();
	}

	initForm() {
		this.form = this._fb.group({
			PE_Nome: ['', Validators.required],
			PE_Email: ['', Validators.required],
			PE_CPF: ['', [Validators.required]],
			PE_Telefone1: ['', Validators.required],
			PE_CEP: ['', Validators.required],
			PE_Logradouro: ['', Validators.required],
			PE_Numero: ['', Validators.required],
			PE_Complemento: [''],
			PE_Bairro: ['', Validators.required],
			PE_Cidade: ['', Validators.required],
			PE_UF: ['', Validators.required]
		});
	}

	getAddressAcquirertData(event) {
		this.form?.patchValue({
			PE_Cidade: event.localidade,
			PE_Bairro: event.bairro,
			PE_Logradouro: event.logradouro,
			PE_UF: event.uf,
			PE_Numero: event.numero,
			PE_Complemento: event.complemento,
			PE_CEP: event.CEP
		});
		this.form.updateValueAndValidity();
	}

	updateForm() {
		this.form.patchValue({
			PE_Nome: this.subject.PE_Nome,
			PE_Email: this.subject.PE_Email,
			PE_CPF: this.subject.PE_CPF,
			PE_Telefone1: this.subject.PE_Telefone1,
			PE_CEP: this.subject.PE_CEP,
			PE_Logradouro: this.subject.PE_Logradouro,
			PE_Numero: this.subject.PE_Numero,
			PE_Complemento: this.subject.PE_Complemento,
			PE_Bairro: this.subject.PE_Bairro,
			PE_Cidade: this.subject.PE_Cidade,
			PE_UF: this.subject.PE_UF
		});
	}

	saveRegistration() {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			Swal.fire({
				title: 'Formulário incompleto',
				text: 'Por favor, preencha todos os campos obrigatórios corretamente.',
				icon: 'warning',
				confirmButtonColor: '#417bff',
				confirmButtonText: 'OK',
			});
		}
		else {
			this.global.startLoading('Salvando informações...', true);
			this.userService.updateRegistrationUser(this.subject.USR_CodigoPessoa, this.form.value).subscribe({
				next: (response: any) => {
					this.global.stopLoading();
					
					const userRaw = JSON.parse(localStorage.getItem('user'));
					userRaw.PE_UltimaAtualizacaoCadastral = moment().format('YYYY-MM-DD');
					userRaw.PE_Telefone1 = this.form.get('PE_Telefone1').value;
					userRaw.PE_Email = this.form.get('PE_Email').value;
					localStorage.removeItem('user');
					localStorage.setItem('user', JSON.stringify(userRaw));

					Swal.fire({
						title: 'Atualização Cadastral',
						text: `${response.message} Você será redirecionado para a próxima tela.`,
						icon: 'success',
						showCancelButton: false,
						showConfirmButton: true,
						confirmButtonColor: '#417bff',
						confirmButtonText: 'OK',
					}).then(() => {
						this.isDisabled = false;
						window.location.reload();					
					});
				},
				error: (error: any) => {
					console.log('Error:', error)
				},
			});
		}
	}
}